var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 10,
    viewBox: "0 0 33 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6091 0.166016H12.9726L11.3259 9.82774H13.9581L15.6091 0.166016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76294 9.81683L11.9096 0.171387H9.11916L6.53961 6.76132L6.26428 5.76633C5.75863 4.56934 4.3135 2.8465 2.61694 1.76195L4.97491 9.82009L7.76294 9.81683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1308 6.66862C23.1406 5.5717 22.4361 4.73504 20.9182 4.04398C19.9956 3.59764 19.4333 3.3 19.4401 2.84707C19.4401 2.44691 19.9163 2.01707 20.948 2.01707C21.8113 2.00382 22.4329 2.19228 22.9191 2.3874L23.1573 2.49658L23.5146 0.403488C22.992 0.208295 22.175 0 21.1533 0C18.5505 0 16.7184 1.3095 16.7018 3.18764C16.6852 4.57649 18.0116 5.35023 19.0102 5.81308C20.0354 6.28489 20.3793 6.58682 20.3727 7.01008C20.3662 7.65724 19.5558 7.95236 18.7985 7.95236C17.7435 7.95236 17.1846 7.80691 16.3177 7.44584L15.9809 7.29113L15.6108 9.45617C16.2255 9.72479 17.3631 9.95959 18.5439 9.96936C21.3118 9.96936 23.111 8.67651 23.1308 6.66862Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2626 8.38035C26.5636 8.38035 29.2523 8.38368 29.6361 8.38368C29.7154 8.72011 29.9568 9.8319 29.9568 9.8319H32.4008L30.2676 0.176758H28.2338C27.6021 0.176758 27.1326 0.348709 26.8547 0.976851L22.9424 9.8319H25.7106C25.7104 9.8319 26.1601 8.64172 26.2626 8.38035ZM28.0682 3.70149C28.0552 3.72791 28.2866 3.1427 28.4189 2.77896L28.5974 3.61214C28.5974 3.61214 29.1003 5.92026 29.206 6.40303H27.0199C27.2383 5.84758 28.0682 3.70149 28.0682 3.70149Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.155 5.13398L5.26497 0.865116C5.11283 0.276427 4.67011 0.101294 4.11693 0.078125H0.0363504L0 0.273171C3.17819 1.04351 5.28111 2.90188 6.155 5.13398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.329ad433a329a4d5fc0465578aae91e8.svg";
export { ForwardRef as ReactComponent };